import { useFeatureIsOn } from '@growthbook/growthbook-react';
import React from 'react';
import TablesContainerLegacy from './container';
import TablesContainerV2 from './containerV2';

type ContainerVersionProps = {
  language: string;
  openModal: boolean;
  openModalWith: string | { value: string | string[] | undefined };
};

export const ContainerVersion: React.FC<ContainerVersionProps> = (props) => {
  const useV2 = useFeatureIsOn('tables-v2');
  if (useV2) return <TablesContainerV2 {...props} />;
  return <TablesContainerLegacy {...props} />;
};
